// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityRenderHtmlInReportViewer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security Render Html In Report Viewer Component
 */
!(function () {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var Input = require('share/components/controls/Izenda.Input');
  var EventsUtils = require('EventUtils');

  var SecurityRenderHtmlInReportViewer = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },
   
    renderRenderHtmlInReportViewer: function (bundle) {
      var notifyChange = EventsUtils.notifyChange;
      var model = this.props.store.model;

      return (
          <div className="form-group">
            <label className="col-md-7 col-xs-6 control-label field-name">
              <span>{bundle.LABEL.RENDER_HTML_IN_REPORT_VIEWER_LABEL}</span>
              <i className="icon-info-circled"
                 title={bundle.TOOLTIP.RENDER_HTML_IN_REPORT_VIEWER_TOOLTIP}/>
            </label>
            <div className="col-md-5 col-xs-6 u_controlHeight">
              <Input
                type='checkbox'
                checked={model.renderHtmlInReportViewerValue}
                onChange={notifyChange(model.updateRenderHtmlInReportViewerValue.bind(model), EventsUtils.CHECKBOX)}
              />
            </div>
          </div>
      )
    },

    render: function () {
      var store = this.props.store;
      var bundle = store.getBundle();

      return (
          <div className="form-horizontal">
            {this.renderRenderHtmlInReportViewer(bundle)}
          </div>
      )
    },
  });

  module.exports = observer(SecurityRenderHtmlInReportViewer);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.SecurityRenderHtmlInReportViewer.jsx